import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import TablePreferencesActions from 'sharedreact/actions/TablePreferencesActions';
import asFunctional from 'sharedreact/components/asFunctional';
import TableSortPreferences from 'sharedreact/data/TableSortPreferences';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import TablePreferencesStore from 'sharedreact/stores/TablePreferencesStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import ViewSessionsActions from 'workspaces/launcher/actions/ViewSessionsActions';
import ViewSessionsTab from 'workspaces/launcher/components/admin/ViewSessionsTab';
import ViewSessionsStore from 'workspaces/launcher/stores/ViewSessionsStore';

type Props = {
  index: number,
  activeTab: number
};

type State = ConstructorParameters<typeof ViewSessionsTab>[0];

function getStores () {
  return [
    SettingsStore,
    ViewSessionsStore
  ];
}

function handleLoad (): void {
  setTimeout(() => {
    const tableName = 'ViewSessionsTable';

    const prefsSortOrderPrefs: TableSortPreferences | undefined = TablePreferencesStore.getSortPreferences(tableName);
    if (!prefsSortOrderPrefs) {
      const selectedColumns: Immutable.Set<string> = Immutable.Set.of('user', 'documents', 'started');
      TablePreferencesActions.setSelectedColumns(tableName, selectedColumns);
    }
    ViewSessionsActions.setSortOrder(TablePreferencesStore.getTableSortOrder(
      tableName,
      ViewSessionsStore.getInitialSortOrder()
    ));
    ViewSessionsActions.fetchMaxSessions();
    ViewSessionsActions.fetch();
  });
}

function handleLeave (): void {
  // cleanup ?
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    index: props.index,
    activeTab: props.activeTab,
    language: SettingsStore.getLanguage(),
    sessions: ViewSessionsStore.getItems(),
    sortOrder: ViewSessionsStore.getSortOrder(),
    isFetching: ViewSessionsStore.isFetching(),
    onSortOrderChange: ViewSessionsActions.setSortOrder,
    onLoad: handleLoad,
    onLeave: handleLeave
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(ViewSessionsTab),
  getStores,
  calculateState,
  { withProps: true }
);
